<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="isLoading$ | async">
  <div right>
    @if (((isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) && (hasActiveUsersEnabled$ | async)) {
      <button
        mat-icon-button
        type="button"
        (click)="goToActiveUsers()"
        [matTooltip]="'organization_unit_details.active_users.tooltip' | translate"
        >
        <mat-icon>supervised_user_circle</mat-icon>
      </button>
    }
    @if (isAdmin$ | async) {
      <button
        mat-icon-button
        type="button"
        (click)="goToActivities()"
        [matTooltip]="'organization_unit_details.user_activity.tooltip' | translate"
        >
        <mat-icon>assignment</mat-icon>
      </button>
    }
  </div>
</app-doenkids-menu-bar>
<div content class="organization-unit-details-content" (scroll)="onScroll($event)">
  <mat-tab-group #tabs [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="handleTabChange($event)" [class.tab-scrolled]="scrolled$ | async" mat-stretch-tabs="false" mat-align-tabs="start">
    @if ((isAdmin$ | async) || (isReader$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
      <mat-tab
        [label]="'organization_unit_details.tab.general_info' | translate"
        >
        <ng-template matTabContent>
          <form [formGroup]="form">
            <div class="import-buttons">
              <div class="export-buttons">
                @if ((isDoenkidsOrganization$ | async) && (isAdmin$ | async)) {
                  <button mat-button color="accent" (click)="syncJibbie()">
                    {{ 'organization_unit_details.export.jibbie' | translate }}
                    <mat-icon>sync</mat-icon>
                  </button>
                }
                @if ((isDoenkidsOrganization$ | async) && (isAdmin$ | async)) {
                  <button mat-button color="accent" (click)="exportOUData()">
                    {{ 'organization_unit_details.export.excel' | translate }}
                    <mat-icon svgIcon="excel"></mat-icon>
                  </button>
                }
                @if ((isDoenkidsOrganization$ | async) && (isAdmin$ | async)) {
                  <button mat-button color="accent" (click)="exportFinance()">
                    {{ 'organization_unit_details.export.finance' | translate }}
                    <mat-icon svgIcon="excel"></mat-icon>
                  </button>
                }
              </div>
              @if ((isAdmin$ | async) || (!(isAdmin$ | async) && !(isReader$ | async) && (hasOUWritePermissions$ | async))) {
                <div
                  class="save-button-container flex-row justify-start"
                  >
                  <button
                    mat-button
                    class="save-button"
                    type="submit"
                    [disabled]="(!form.dirty && !customerFormDirty) || form.invalid"
                    (click)="saveDetails()"
                    [matTooltip]="'organization_unit_details.save.tooltip' | translate"
                    >
                    <mat-icon>save</mat-icon>
                    {{ 'generic.save_changes' | translate }}
                  </button>
                </div>
              }
              </div>
            <div class="tab-content-wrapper">
              <div class="organisation-name gap-4 lg-flex-col">
                <div class="organisation-name-details flex-col gap-4">
                  <h4 class="permissions-title">{{ 'organization_unit.organization_details.title' | translate }}</h4>
                  <mat-form-field [appearance]="inputAppearance">
                    <mat-label>{{ 'organization_unit.name.label' | translate }}</mat-label>
                    <input [readOnly]="readOnly" formControlName="name" matInput />
                  </mat-form-field>
                  @if ((ouCountryCode$ | async)?.toLowerCase() === 'nl') {
                    <div>
                      <mat-form-field [appearance]="inputAppearance">
                        <mat-label>{{ 'organization_unit.lrk_number.label' | translate }}</mat-label>
                        <input readonly formControlName="lrkIdentifier" matInput />
                        @if ((isAdmin$ | async) || (hasCustomerWritePermission$ | async)) {
                          <div matSuffix class="lrk-suffix">
                            <button mat-icon-button (click)="chooseLrkIdentifier($event)">
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              mat-icon-button
                              (click)="clearLrkIdentifier($event)"
                              [disabled]="!form.get('lrkIdentifier').value || form.get('lrkIdentifier').value === ''"
                              >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        }
                      </mat-form-field>
                      @if (((isAdmin$ | async) || (hasCustomerWritePermission$ | async)) && parentLrkIdentifier && !form.get('lrkIdentifier').value) {
                        <p class="inherited-lrk-disclaimer">
                          <mat-icon>info</mat-icon>
                          {{ 'organization_unit.lrk_number.admin_inherited_hint' | translate: { lrkNumber: parentLrkIdentifier } }}
                        </p>
                      }
                    </div>
                  }
                  <mat-form-field [appearance]="inputAppearance">
                    <mat-label>{{ 'organization_unit.kostenplaats.label' | translate }}</mat-label>
                    <input [readOnly]="readOnly" formControlName="kostenplaats" matInput />
                  </mat-form-field>
                </div>
                <div class="flex-col">
                  @if ((isAdmin$ | async) && (isOrganizationOfTypeLocation$ | async)) {
                    <mat-form-field color="primary" class="oko-type-field">
                      <mat-label>{{ 'organization_unit.activity_type.placeholder' | translate }}</mat-label>
                      <mat-select formControlName="activity_type_id">
                        @for (type of possibleActivityTypes; track type) {
                          <mat-option [value]="type.id">
                            {{ type.name }}
                          </mat-option>
                        }
                        @if ((ouCountryCode$ | async)?.toLowerCase() === 'nl') {
                          <mat-option value="IKC">{{ 'activity_type.integral_child_center.abbreviation' | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <div class="financial-note-wrapper flex-col gap-4">
                    @if (isAdmin$ | async) {
                      <form class="flex-col gap-4" [formGroup]="financialForm">
                        <mat-form-field [appearance]="inputAppearance">
                          <mat-label>{{ 'organization_unit.billing.start_month.label' | translate }}</mat-label>
                          <mat-select [placeholder]="'organization_unit.billing.start_month.placeholder' | translate" formControlName="billingStartMonth">
                            @for (month of months$ | async; track month) {
                              <mat-option [value]="month.value">
                                {{ month.viewValue | titlecase }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field [appearance]="inputAppearance">
                          <mat-label>{{ 'organization_unit.billing.frequency.label' | translate }}</mat-label>
                          <input formControlName="billingFrequency" matInput />
                        </mat-form-field>
                        <mat-form-field color="primary" class="financial-note-field">
                          <mat-label>{{ 'organization_unit.financial_note.label' | translate }}</mat-label>
                          <textarea formControlName="financialNote" matInput></textarea>
                          @if (financialForm.get('financialNote').disabled) {
                            <button mat-icon-button matSuffix (click)="editFinancialNote()">
                              <mat-icon>edit</mat-icon>
                            </button>
                          }
                        </mat-form-field>
                      </form>
                    }
                    @if ((isAdmin$ | async) && (possibleContentLanguages$ | async); as contentLanguages) {
                      <mat-form-field [appearance]="inputAppearance">
                        <mat-label>{{ 'content_language.posbbile.label' | translate }}</mat-label>
                        <mat-select multiple formControlName="contentLanguages">
                          @for (contentLanguage of possibleContentLanguages$ | async; track contentLanguage) {
                            <mat-option [value]="contentLanguage">
                              {{ 'generic.language.' + contentLanguage.toLowerCase() | translate | titlecase }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (form.get('contentLanguages').hasError('required')) {
                          <mat-error>{{ 'generic.language.form.required' | translate }}</mat-error>
                        }
                      </mat-form-field>
                    }
                    @if ((hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) && (isOrganizationOfTypeLocation$ | async)) {
                      <mat-checkbox
                        formControlName="test_organization"
                        color="primary"
                        class="test-organization-field"
                        [matTooltip]="'organization_unit.is_test.tooltip' | translate"
                        >
                        {{ 'organization_unit.is_test.label' | translate }}
                      </mat-checkbox>
                    }
                  </div>
                </div>
              </div>
              @if ((isAdmin$ | async) || (hasCustomerWritePermission$ | async)) {
                <div class="customer-details-section">
                  <app-organization-unit-customer-form
                    #customerFormComponent
                    [organizationUnitId]="selectedOrganizationUnitId"
                    [inputAppearance]="inputAppearance"
                    [isAdmin$]="isAdmin$"
                    [hasCustomerWritePermission$]="hasCustomerWritePermission$"
                    [isReadOnly]="readOnly"
                    (formChange)="onCustomerFormChange($event)">
                  </app-organization-unit-customer-form>
                </div>
              }
              @if ((isAdmin$ | async) && !(isDoenkidsOrganization$ | async)) {
                <div class="permissions">
                  <h4 class="permissions-title">{{ 'organization_unit.permissions.heading' | translate }}</h4>
                  <div class="permissions-wrapper">
                    @if ((trickleDownPermissionsText$ | async); as trickleDownPermissionsText) {
                      <p class="trickle-down-text">
                        {{ trickleDownPermissionsText }}
                      </p>
                    }
                    @for (permissionCategory of permissionsMap; track permissionCategory) {
                      <div class="category" *ngVar="parentPermissionOrigins$ | async as parentPermissions">
                        <mat-checkbox
                          [checked]="hasAllPermissions(permissionCategory)"
                          [indeterminate]="hasSomePermissions(permissionCategory)"
                          (change)="setCategoryPermissions(permissionCategory, $event.checked)"
                          >
                          <h4 class="category-title">{{ permissionCategory.viewValue | translate }}</h4>
                        </mat-checkbox>
                        <div class="category-permissions">
                          @for (permission of permissionCategory.permissions; track permission) {
                            @if (permission.visible) {
                              <mat-checkbox [formControlName]="permission.formControlName">
                                {{ permission.viewValue | translate }} {{ getPermissionOrigin(permission.formControlName, parentPermissions) }}
                              </mat-checkbox>
                            }
                          }
                          @for (permission of permissionCategory.inheritingPermissions; track permission) {
                            @if (permission.visible) {
                              <mat-checkbox [formControlName]="permission.formControlName">
                                {{ permission.viewValue | translate }} {{ getPermissionOrigin(permission.formControlName, parentPermissions) }}
                              </mat-checkbox>
                            }
                          }
                        </div>
                      </div>
                    }
                    <h4>{{ 'organization_unit.other_permissions.heading' | translate }}</h4>
                    @for (remainingPermission of remainingPermissions; track remainingPermission) {
                      @if (remainingPermission.visible) {
                        <mat-checkbox [formControlName]="remainingPermission.formControlName">
                          {{ remainingPermission.viewValue | translate }}
                        </mat-checkbox>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </form>
          @if (!readOnly && !(isReader$ | async) && floatingActionButtons.length > 0) {
            <doenkids-speed-dial
              class="speeddial-container"
              [fabButtons]="floatingActionButtons"
              (fabClick)="speedDialClick($event)"
            ></doenkids-speed-dial>
          }
        </ng-template>
      </mat-tab>
    }
    @if (isOrganizationOfTypeCoorporate$ | async) {
      <mat-tab [label]="'organization_unt_detail.tab.organizations' | translate">
        <ng-template matTabContent>
          <app-organization-unit-table
            [organizationUnitId]="selectedOrganizationUnitId"
            [organizationUnitTypeId]="EOrganizationUnitType.ORGANIZATION"
            [editable]="isAdmin$ | async"
            [canAddNewItem]="isAdmin$ | async"
            (listLoading$)="setChildListLoading($event)"
          ></app-organization-unit-table>
        </ng-template>
      </mat-tab>
    }
    @if (isOrganizationOfTypeCustomer$ | async) {
      <mat-tab [label]="'organization_unit_detail.tab.locations' | translate">
        <ng-template matTabContent>
          <app-organization-unit-table
            [organizationUnitId]="selectedOrganizationUnitId"
            [organizationUnitTypeId]="EOrganizationUnitType.LOCATION"
          [editable]="
            (isAdmin$ | async) ||
            (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) ||
            (hasWritePermissionOnAtLeastOneLocationOUInCurrentNodeTree$ | async)
          "
            [canAddNewItem]="isAdmin$ | async"
            (listLoading$)="setChildListLoading($event)"
            [jibbieDetails]="jibbieDetails"
          ></app-organization-unit-table>
        </ng-template>
      </mat-tab>
    }
    @if (isOrganizationOfTypeLocation$ | async) {
      <mat-tab [label]="'organization_unit_detail.tab.groups' | translate">
        <ng-template matTabContent>
          <app-organization-unit-table
            [organizationUnitId]="selectedOrganizationUnitId"
            [organizationUnitTypeId]="EOrganizationUnitType.GROUP"
          [editable]="
            (isAdmin$ | async) ||
            (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) ||
            (hasWritePermissionOnAtLeastOneLocationOUInCurrentNodeTree$ | async)
          "
          [canAddNewItem]="
            (isAdmin$ | async) ||
            (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async) ||
            (hasWritePermissionOnAtLeastOneLocationOUInCurrentNodeTree$ | async)
          "
            (listLoading$)="setChildListLoading($event)"
          ></app-organization-unit-table>
        </ng-template>
      </mat-tab>
    }
    @if ((hasTemplateOptionsPermission$ | async) && (isAdmin$ | async)) {
      <mat-tab [label]="'organization_unit_detail.tab.template_settings' | translate">
        <ng-template matTabContent>
          <app-pdf-writer-template-settings [organizationUnitId]="selectedOrganizationUnitId"></app-pdf-writer-template-settings>
        </ng-template>
      </mat-tab>
    }
    <!-- The vision exists to steer AI, so it lives with the AI settings rather
         than in a narrow column of the general tab. -->
    @if ((isOrganizationOfTypeCustomer$ | async) && ((isAdmin$ | async) || (hasCustomerWritePermission$ | async))) {
      <mat-tab [label]="'organization_unit_detail.tab.ai' | translate">
        <ng-template matTabContent>
          <div class="tab-content-wrapper tab-content-wrapper--ai">
            <!-- AI enablement and budget are DoenKids-controlled: administrators only. -->
            @if (isAdmin$ | async) {
              <app-organization-unit-ai-config-form
                [organizationUnitId]="selectedOrganizationUnitId"
              ></app-organization-unit-ai-config-form>
            }

            <app-organization-unit-vision-form
              [organizationUnitId]="selectedOrganizationUnitId"
              [canEdit]="((isAdmin$ | async) || (hasCustomerWritePermission$ | async)) === true && !readOnly"
            ></app-organization-unit-vision-form>
          </div>
        </ng-template>
      </mat-tab>
    }
    @if ((translations$ | async) && (isAdmin$ | async)) {
      <mat-tab [label]="'organization_unit_detail.tab.translations' | translate">
        <ng-template matTabContent>
          <app-translations [translations]="translations$ | async"></app-translations>
        </ng-template>
      </mat-tab>
    }
    @if ((hasCustomerSymbolsPermission$ | async) && (isAdmin$ | async)) {
      <mat-tab [label]="'organization_unit_detail.tab.customer_symbols' | translate">
        <ng-template matTabContent>
          <app-customer-symbols [organizationUnitId]="selectedOrganizationUnitId"></app-customer-symbols>
        </ng-template>
      </mat-tab>
    }
    @if (isAdmin$ | async) {
      <mat-tab [label]="'organization_unit_detail.tab.users' | translate">
        <ng-template matTabContent>
          <app-organization-users [organizationUnitId]="selectedOrganizationUnitId" (listLoading$)="setChildListLoading($event)"></app-organization-users>
        </ng-template>
      </mat-tab>
    }
    @if (
      (hasKonnectIntegrationPermission$ | async) &&
      (isAdmin$ | async) &&
      ((isOrganizationOfTypeCustomer$ | async) || (isOrganizationOfTypeLocation$ | async)) &&
      (canSetKonnectIntegrationSettingsPermission$ | async)
      ) {
      <mat-tab
        [label]="'organization_unit_details.tab.konnect' | translate"
        >
        <ng-template matTabContent>
          <app-konnect-form [organizationUnitId]="selectedOrganizationUnitId"></app-konnect-form>
        </ng-template>
      </mat-tab>
    }
    @if ((hasJibbieIntegrationPermission$ | async) && (isAdmin$ | async) && (isOrganizationOfTypeCustomer$ | async)) {
      <mat-tab
        [label]="'organization_unit_details.tab.jibbie' | translate"
        >
        <ng-template matTabContent>
          <div class="tab-content-wrapper">
            <h2>{{ 'organization_unit.tab.jibbie.heading' | translate }}</h2>
            <mat-slide-toggle
              color="primary"
              (change)="toggleJibbie($event)"
              [(ngModel)]="isLinkedWithJibbie"
            [innerHtml]="
              'organization_unit.jibbie.link_status'
                | translate
                  : {
                      isLinkedWithJibbie: this.isLinkedWithJibbie,
                      organization: jibbieDetails?.name
                    }
            "
          ></mat-slide-toggle>
        </div>
      </ng-template>
    </mat-tab>
  }
  @if (!(isReader$ | async) && (isOrganizationOfTypeCustomer$ | async) && (hasNewsItemPermission$ | async)) {
    <mat-tab
      [label]="'organization_unit_details.news_item.label' | translate"
      #newsFeedTab
      >
      <ng-template matTabContent>
        <app-organization-unit-manage-newsfeed #manageNewsfeedComponent></app-organization-unit-manage-newsfeed>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
</div>
<div fixed>
  <router-outlet></router-outlet>
</div>
</app-page-content>
